import {
  GET_SHIFT_START,
  SHIFT_START_SUCCESS,
  SHIFT_START_ERROR,
  GET_SHIFT_END,
  SHIFT_END_SUCCESS,
  SHIFT_END_ERROR,
  GET_DEPARTMENT_USER_DATA,
  DEPARTMENT_USER_DATA_SUCCESS,
  DEPARTMENT_USER_DATA_ERROR,
  GET_COMPANY_SEAT_DATA,
  COMPANY_SEAT_DATA_SUCCESS,
  COMPANY_SEAT_DATA_ERROR,
  POST_SEAT_BOOKING,
  SEAT_BOOKING_SUCCESS,
  AVAILABLE_SEAT_SUCCESS,
  AVAILABLE_SEAT_ERROR,
  SEAT_BOOKING_ERROR,
  GET_ROSTER_BOOKING_DATA,
  ROSTER_BOOKING_DATA_SUCCESS,
  ROSTER_BOOKING_DATA_ERROR,
  GET_ROSTER_DEPARTMENT_DATA,
  ROSTER_DEPARTMENT_DATA_SUCCESS,
  ROSTER_DEPARTMENT_DATA_ERROR,
  POST_SEAT_BOOKING_NEW,
  GET_ASSIGN_SEAT,
  ASSIGN_DATA_SUCCESS,
  ASSIGN_DATA_ERROR,
  GET_ASSIGN_SEAT_ERROR,
  RESET_DATA,
} from '../type';
import axios from 'axios';
import {
  getDepartmentMasterListByUser,
  getDepartmentUser,
  getComapnySeat,
  getShiftTiming,
  postRoster,
  checkSeatRoster,
} from '../../Component/Helpers/api';

import { toast } from 'react-toastify';


export const getDepartmentList = (companyID, userId) => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'))
  dispatch({ type: GET_ROSTER_DEPARTMENT_DATA });
  axios
    .get(`${getDepartmentMasterListByUser}/${companyID}/${userId}`, {
      headers: {
        Authorization: authToken?.spintlyToken,
      }
    })
    .then(res => {
      if (res.status === 200) {
        dispatch({
          type: ROSTER_DEPARTMENT_DATA_SUCCESS,
          payload: res.data.objectDept,
        });
      } else {
        dispatch({
          type: ROSTER_DEPARTMENT_DATA_ERROR,
          payload: res.data.error,
        });
      }
    })
    .catch(error => {
      dispatch({ type: ROSTER_DEPARTMENT_DATA_ERROR, payload: error });
    });
};

export const getFilterData = (
  companyID,
  departmentId,
  timeType,
) => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'))
  dispatch({
    type: timeType === 'start_time' ? GET_SHIFT_START : GET_SHIFT_END,
  });
  axios
    .get(`${getShiftTiming}/${companyID}/${departmentId}/${timeType}`, {
      headers: {
        Authorization: authToken?.spintlyToken,
      }
    })
    .then(res => {
      if (res.status === 200) {
        dispatch({
          type:
            timeType === 'start_time' ? SHIFT_START_SUCCESS : SHIFT_END_SUCCESS,
          payload: res.data.refData,
        });
      } else {
        dispatch({
          type: timeType === 'start_time' ? SHIFT_START_ERROR : SHIFT_END_ERROR,
          error: res.data.error,
        });
      }
    })
    .catch(error => {
      dispatch({
        type: timeType === 'start_time' ? SHIFT_START_ERROR : SHIFT_END_ERROR,
        error: error,
      });
    });
};

export const getDepartmentUserData = (
  companyID,
  departmentId,
  locationId,
) => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'))
  dispatch({
    type: GET_DEPARTMENT_USER_DATA,
  });
  axios
    .get(`${getDepartmentUser}/${companyID}/${departmentId}/${locationId}`, {
      headers: {
        Authorization: authToken?.spintlyToken,
      }
    })
    .then(res => {
      if (res.status === 200) {
        dispatch({
          type: DEPARTMENT_USER_DATA_SUCCESS,
          payload: res.data.data,
        });
        if (res.data.data.length == 0) {
          toast.error('No Employee is mapped with this department ', {
            
            // autoClose: false,
            // closeButton: CloseToastButton,
          });
        }
      } else {
        dispatch({
          type: DEPARTMENT_USER_DATA_ERROR,
          error: res.data.error,
        });
      }
    })
    .catch(error => {
      dispatch({
        type: DEPARTMENT_USER_DATA_ERROR,
        error: error,
      });
    });
};

export const getCompanySeatData = (companyID, locationId) => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'))
  dispatch({
    type: GET_COMPANY_SEAT_DATA,
  });
  axios
    .get(`${getComapnySeat}/${companyID}/${locationId}`, {
      headers: {
        Authorization: authToken?.spintlyToken,
      }
    })
    .then(res => {
      if (res.status === 200) {
        dispatch({
          type: COMPANY_SEAT_DATA_SUCCESS,
          payload: res.data.data,
        });
        if (res.data.data.length == 0) {
          toast.error('No Seat is mapped with this department ', {
            
            // autoClose: false,
            // closeButton: CloseToastButton,
          });
        }
      } else {
        dispatch({
          type: COMPANY_SEAT_DATA_ERROR,
          error: res.data.error,
        });
      }
    })
    .catch(error => {
      dispatch({
        type: COMPANY_SEAT_DATA_ERROR,
        error: error,
      });
    });
};

export const postSeatBookingData = (
  companyID,
  departmentId,
  seatArray,
) => dispatch => {
  dispatch({
    type: POST_SEAT_BOOKING,
  });
  let authToken = JSON.parse(localStorage.getItem('headData'))
  axios
    .post(`${postRoster}/${companyID}/${departmentId}`, seatArray, {
      headers: {
        Authorization: authToken?.spintlyToken,
      }
    })
    .then(res => {
      if (res.status === 200) {
        dispatch({
          type: SEAT_BOOKING_SUCCESS,
          payload: res.data.data,
        });
        if (res.data.message && res.data.message.length > 0) {
          if (Array.isArray(res.data.message)) {
            res.data.message.forEach(message => {
              if (message.status === 'success') {
                toast.info(message.message, {
                  
                  // autoClose: false,
                  // closeButton: CloseToastButton,
                });
              } else {
                toast.error(message.message, {
                  
                  // autoClose: false,
                  // closeButton: CloseToastButton,
                });
              }
            });
          } else {
            toast.error(res.data.message, {
              
              // autoClose: false,
              // closeButton: CloseToastButton,
            });
          }
        }
      } else {
        dispatch({
          type: SEAT_BOOKING_ERROR,
          error: res.data.error,
        });
        toast.error(res.data.message, {
          
          // autoClose: false,
          // closeButton: CloseToastButton,
        });
      }
    })
    .catch(error => {
      dispatch({
        type: SEAT_BOOKING_ERROR,
        error: error,
      });
    });
};

export const postSeatBookingDataNew = data => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'))
  dispatch({
    type: POST_SEAT_BOOKING_NEW,
  });
  axios
    .post(`${checkSeatRoster}`, data, {
      headers: {
        Authorization: authToken?.spintlyToken,
      }
    })
    .then(res => {
      if (res.status === 200) {
      
        dispatch({
          type: AVAILABLE_SEAT_SUCCESS,
          payload: res.data.data,
        });
        if (res.data.message && res.data.message.length > 0) {
          if (Array.isArray(res.data.message)) {
            res.data.message.forEach(message => {
              if (message.status === 'success') {
                toast.info(message.message, {
                  
                  // autoClose: false,
                  // closeButton: CloseToastButton,
                });
              } else {
                toast.error(message.message, {
                  
                  // autoClose: false,
                  // closeButton: CloseToastButton,
                });
              }
            });
          } else {
            toast.error(res.data.message, {
              
              // autoClose: false,
              // closeButton: CloseToastButton,
            });
          }
        }
      } else {
        dispatch({
          type: AVAILABLE_SEAT_ERROR,
          error: res.data.error,
        });
        toast.error(res.data.message, {
          
          // autoClose: false,
          // closeButton: CloseToastButton,
        });
      }
    })
    .catch(error => {
      dispatch({
        type: AVAILABLE_SEAT_ERROR,
        error: error,
      });
    });
};

export const getRosterBookingData = (
  companyID,
  departmentId,
  locationId,
  startDate,
  endDate,
  userIds,
) => dispatch => {
  dispatch({
    type: GET_ROSTER_BOOKING_DATA,
  });
  let authToken = JSON.parse(localStorage.getItem('headData'))
  axios
    .post(
      `${process.env.REACT_APP_API_URL}roster/seatRosterData/${companyID}/${departmentId}/${locationId}/${startDate}/${endDate}`,
      userIds, {
      headers: {
        Authorization: authToken?.spintlyToken,
      }
    }
    )
    .then(res => {
     
      if (res.status === 200) {
        dispatch({
          type: ROSTER_BOOKING_DATA_SUCCESS,
          payload: res.data.refData,
        });
      } else {
        dispatch({
          type: ROSTER_BOOKING_DATA_ERROR,
          error: res.data.error,
        });
      }
    })
    .catch(error => {
      dispatch({
        type: ROSTER_BOOKING_DATA_ERROR,
        error: error,
      });
    });
};

export const postAutoAssign = (
  departmentId,
  startSeatId,
  spoc_email,
  spoc_name,
  spoc_id,
  data,
) => dispatch => {
  dispatch({
    type: GET_ASSIGN_SEAT,
  });
  let authToken = JSON.parse(localStorage.getItem('headData'))
  axios
    .post(
      `${process.env.REACT_APP_API_URL}roster/autoAssignSeat?departmentId=${departmentId}&startSeatId=${startSeatId ? startSeatId : 0
      }&spoc_email=${spoc_email}&spoc_name=${spoc_name}&spoc_id=${spoc_id}`,
      data, {
      headers: {
        Authorization: authToken?.spintlyToken,
      }
    }
    )
    .then(res => {
      if (res.status === 200) {
        dispatch({
          type: ROSTER_BOOKING_DATA_SUCCESS,
          payload: res.data.data,
        });
        dispatch({
          type: ASSIGN_DATA_SUCCESS,
          payload: res.data.data,
        });
        toast.info('Auto Assign Completed Successfully.', {
          
          // autoClose: false,
          // closeButton: CloseToastButton,
        });
      } else {
        dispatch({
          type: ROSTER_BOOKING_DATA_ERROR,
          error: res.data.error,
        });
      }
    })
    .catch(error => {
      dispatch({
        type: ROSTER_BOOKING_DATA_ERROR,
        error: error,
      });
    });
};
export const resetUser = users => dispatch => {
 
  dispatch({
    type: RESET_DATA,
    payload: users,
  });
};
